import React from 'react';
import { TopTrustBar, Masthead, Hero } from './components/Header';
import { FounderBlock, SymptomStrip, ProblemSection } from './components/Story';
import { ProductReveal, RatingSummary, ReviewCard, HallerExplainer, TwoStepSolution, SpecBlock, IntroducingBlock } from './components/Product';
import { TestimonialCards, FuturePacing, GuaranteeCard } from './components/SocialProof';
import { OfferBlock, EmotionalClose } from './components/Offer';
import { FAQ, FinalCTA, SiteFooter } from './components/Footer';
import { StickyMobileCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-background font-sans text-foreground selection:bg-sage selection:text-primary relative pb-20 md:pb-0" data-id="element-0">
      <TopTrustBar data-id="element-1" />
      <Masthead data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <FounderBlock data-id="element-5" />
        <SymptomStrip data-id="element-6" />
        <ProblemSection data-id="element-7" />

        <ProductReveal data-id="element-8" />
        <RatingSummary data-id="element-9" />
        <ReviewCard data-id="element-10" />
        <HallerExplainer data-id="element-11" />
        <TwoStepSolution data-id="element-12" />
        <SpecBlock data-id="element-13" />
        <IntroducingBlock data-id="element-14" />

        <TestimonialCards data-id="element-15" />
        <FuturePacing data-id="element-16" />
        <GuaranteeCard data-id="element-17" />

        <OfferBlock data-id="element-18" />
        <EmotionalClose data-id="element-19" />

        <FAQ data-id="element-20" />
        <FinalCTA data-id="element-21" />
      </main>

      <SiteFooter data-id="element-22" />
      <StickyMobileCTA data-id="element-23" />
    </div>;
}